import { render, staticRenderFns } from "./AttractionCardVariant2.vue?vue&type=template&id=14732d5f&scoped=true&"
import script from "./AttractionCardVariant2.vue?vue&type=script&lang=js&"
export * from "./AttractionCardVariant2.vue?vue&type=script&lang=js&"
import style0 from "./AttractionCardVariant2.vue?vue&type=style&index=0&id=14732d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14732d5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VImg,VLayout})
